"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const _util_1 = require("../_util");
const common_1 = require("../common");
const icon_1 = __importDefault(require("../icon"));
const prefixCls = common_1.getPrefixCls('image-upload');
const ImageUpload = (props) => {
    const { files = [], onChange, multiple, multipleCount, sizeType, sourceType, deletable = true, disabled, maxCount, children, } = props;
    const handleClickImage = (index) => {
        let urls = files;
        const current = index;
        if (typeof files[index] !== 'string') {
            urls = files.map(i => i.url);
        }
        one_2.previewImage({
            urls: urls,
            current,
            // @ts-ignore
            enablesavephoto: true,
            enableShowPhotoDownload: true,
        });
    };
    const handleAdd = () => __awaiter(void 0, void 0, void 0, function* () {
        if (disabled) {
            return;
        }
        const params = {};
        if (multiple) {
            params.multiple = true;
            params.count = 99;
        }
        if (multipleCount) {
            params.count = multipleCount;
        }
        if (sizeType) {
            params.sizeType = sizeType;
        }
        if (sourceType) {
            params.sourceType = sourceType;
        }
        const [errc, resc] = yield _util_1.to(_util_1.sync(one_2.chooseImage, params));
        if (errc) {
            return;
        }
        const targetFiles = resc.filePaths
            ? resc.filePaths.map((i) => i)
            : resc.tempFilePaths.map((i) => i);
        const newFiles = files.concat(targetFiles);
        onChange === null || onChange === void 0 ? void 0 : onChange(newFiles);
    });
    const handleDelete = (e, index) => {
        e.stopPropagation();
        let newValue = _util_1.deepClone(files);
        newValue.splice(index, 1);
        newValue = newValue.map((item, index) => {
            const newItem = item;
            if (typeof newItem === 'string') {
                return newItem;
            }
            newItem.key = String(index);
            return newItem;
        });
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    return (React.createElement(one_1.View, { className: prefixCls },
        files.map((item, index) => (React.createElement(one_1.View, { key: item.key || index, className: `${prefixCls}-item`, onTap: () => handleClickImage(index) },
            deletable ? (React.createElement(one_1.View, { className: `${prefixCls}-item-delete` },
                React.createElement(one_1.View, { style: { height: '24px' }, onTap: e => {
                        handleDelete(e, index);
                    } },
                    React.createElement(icon_1.default, { type: "close", size: "24px", color: "#FDFFFD", style: {
                            width: '24px',
                            height: '24px',
                            verticalAlign: 'text-top',
                        } })))) : null,
            React.createElement(one_1.Image, { mode: "widthFix", src: item.url || item })))),
        !maxCount || files.length < maxCount ? (React.createElement(one_1.View, { onTap: handleAdd }, children !== null && children !== void 0 ? children : (React.createElement(one_1.View, { className: `${prefixCls}-add` },
            React.createElement(icon_1.default, { type: "add", size: "48px", color: "#BABEC6" }))))) : null));
};
exports.default = ImageUpload;
